import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { LegalFooter } from '@cp-mx/common';
import { fetchLegalFooter } from './LegalFooterSlice';
import { LegalFooterContentSelector } from './LegalFooterContentSelector';

export function useLegalFooter(): AbstractContentState<LegalFooter> {
    return useCmsContent(fetchLegalFooter, LegalFooterContentSelector);
}
